export interface VttType {
  url: string;
  tile_width: number;
  tile_height: number;
  duration: number;
  tiles: VttTile[];
}
export interface VttTile {
  start: number;
  x: number;
  y: number;
}

export const fetchVttJSON = async (url: string): Promise<VttType> =>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  fetch(url).then(async (v) => v.json());
